/*
 * Filter memory for /companies (table + board).
 *
 * Only URL-backed keys can be listed here. On /companies the search box, the
 * page number and the column sort are component state, not the URL (the sort
 * — header and the Sort select alike — is remembered by `useTableFilters`'
 * table memory instead; owner 2026-10-23). /contacts,
 * /companies/:id and /contacts/:id read no search params at all (search, page,
 * sort and the companyId / contactGroupId funnels on /contacts are hook state),
 * so they get no rule.
 */
import type { FilterMemoryRule } from './types';

export const FILTER_MEMORY_COMPANIES: readonly FilterMemoryRule[] = [
  {
    path: '/companies',
    keep: [
      'view', // table (key absent) vs board
      'stageId', // company stage funnel, CSV of ids
      'stageStatusId', // stage status funnel, CSV of ids (list only)
      'accountLeadId', // account lead funnel, CSV of ids (also seeded by the default-lead hook)
      'clientSuccessManagerId', // client success manager funnel, CSV of ids
      'countryId', // country funnel, CSV of ids (list only)
      'regionId', // region funnel, CSV of ids
      'sourceId', // company source funnel, CSV of ids (list only)
      'companyTypeId', // company type funnel, CSV of ids (list only)
      'participatedCycleId', // "projects participated in" cycle funnel, CSV of ids (list only)
      'purchasedCycleId', // "products purchased" cycle funnel, CSV of ids (list only)
    ],
  },
];
